import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import * as moment from 'moment';
import ProjectChildComment from 'src/entities/ProjectChildComment';

export interface ApiProjectChildCommentResponse {
  id: number;
  body: string;
  authorId: number;
  authorName: string;
  parentCommentId: number;
  createdAt: string;
}

interface ApiProjectChildCommentCreateRequest {
}

export class ProjectChildCommentFactory extends BaseFactory<ProjectChildComment> {
  public toEntity(args: ApiProjectChildCommentResponse): ProjectChildComment {
    return new ProjectChildComment({
      id: args.id,
      body: args.body,
      authorId: args.authorId,
      authorName: args.authorName,
      parentCommentId: args.parentCommentId,
      createdAt: moment(args.createdAt),
    });
  }

  public toRequest(projectChildComment: ProjectChildComment): ApiProjectChildCommentCreateRequest {
    return {
      body: projectChildComment.body
    };
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/ProjectChildCommentFactory.tsx